import React, {useState, useEffect} from 'react'
import SearchIcon from '@mui/icons-material/Search';
import { Link, useAsyncError } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import MemberCard from '../../components/MemberCard/memberCard';
import Modal from '../../components/Modal/modal';
import Addmembership from '../../components/Addmembership/addmembership';
import Addmembers from '../../components/Addmebers/addmembers';
import Footer from '../../components/Footer';
import axios from 'axios';
import {toast, ToastContainer} from "react-toastify";

const Member = () => {
const [addMembership, setAddmembership] = useState(false);
const [addMember, setAddmember] = useState(false);
const [data, setData]= useState([]);
const [skip, setSkip] = useState(0);
const [search, setSearch] = useState("");
const [isSearchModeOn, setIsSearchModeOn]=useState(false);

const [currentPage, setCurrentPage] = useState(1);

const [startFrom, setStartFrom] = useState(0);
const [endTo, setEndTo] = useState(9);
const [totalData, setTotalData] = useState(0);
const [limit, setLimit] = useState(9);

const [noOfPage, setNoOfPage] = useState(0);

useEffect(()=>{
  fetchData(0,9);
},[])

const fetchData = async()=>{
// const fetchData = async(skip,limits)=>{
  await axios.get(`${process.env.REACT_APP_FRONTEND_URL}/members/all-member`, {withCredentials:true}).then((response)=>{
  // await axios.get(`${process.env.REACT_APP_FRONTEND_URL}/members/all-member?skip=${skip}&limit=${limits}`, {withCredentials:true}).then((response)=>{
    console.log(response);

      let totalData= response.data.totalMembers;
  setTotalData(totalData);
  setData(response.data.members)

  let extraPage = totalData % limit ===0?0:1;
  let totalPage = parseInt(totalData/limit) + extraPage;
  setNoOfPage(totalData);

if(totalData===0){
  setStartFrom(-1);
  setEndTo(0);
}else if(totalData<10){
setStartFrom(0);
setEndTo(totalData);
}
  }).catch(err=>{
    toast.error("Something Technical Fault");
  })

}


const handleMemberShip = () =>{
  setAddmembership(prev =>!prev);
}
const handleMembers = () =>{
  setAddmember(prev =>!prev);
}

// const handlePrev = ()=>{
//   if(currentPage!==1){
//     let currPage = currentPage-1;
//     setCurrentPage(currPage);
//     var from = (currPage-1)*9;
//     var to = (currPage*9);
//     setStartFrom(from);
//     setEndTo(to);
//     let skipValue = skip - 9;
//     setSkip(skipValue);
//     fetchData(skipValue,9);
//   }
// }

// const handleNext = () =>{
//   if(currentPage!==noOfPage){
//     let currPage = currentPage+1;
//     setCurrentPage(currPage);
//     var from = (currPage-1)*9;
//     var to = (currPage*9);
//     if(to>totalData){
//       to = totalData;
//     }
//     setStartFrom(from);
//     setEndTo(to);
//     let skipValue = skip + 9;
//     setSkip(skipValue);
//     fetchData(skipValue,9);
//   }
// }

const handleSearchData = async()=>{

if(search!==""){
setIsSearchModeOn(true);
await axios.get(`${process.env.REACT_APP_FRONTEND_URL}/members/searched-members?searchTerm=${search}`, {withCredentials:true}).then((response)=>{
setData(response.data.members);
setTotalData(response.data.totalMembers);

}).catch(err=>{
  toast.error("Something Technical Fault");
})
}else{
  if(isSearchModeOn){
    window.location.reload();
  }else{
    toast.error("Please Enter any Value")
  }
}
}

  return (
    
    <div className='dashboard-box'>
{/* Block for Banner */}
<div class="member-bar">

    {/* Search  */}
        {/* <div className="search-container">
          <input
          value={search}
          onChange={(e)=>{setSearch(e.target.value)}}
            type="text"
            placeholder="Search members..."
            className="search"
          />
          <button 
          onClick={()=>{handleSearchData()}}
          className="btn search-btn">
            <SearchIcon fontSize="small" />
          </button>
        </div> */}



 {/* Search  */}

<form
  className="search-container"
  onSubmit={(e) => {
    e.preventDefault();   // page reload रोकता है
    handleSearchData();   // search function
  }}
>
  <input
    value={search}
    onChange={(e) => setSearch(e.target.value)}
    type="text"
    placeholder="Search members..."
    className="search"
  />

  <button type="submit" className="btn search-btn">
    <SearchIcon fontSize="small" />
  </button>
</form>

<div className='botton2'> 
        {/* botton */}
  <button className="btn blue" onClick={()=>handleMembers()}>Add Members</button>
  <button className="btn green" onClick={()=>handleMemberShip()} >Membership</button>
 </div>

</div>

{/* Block for back to dashboard */}

<div className='member1'>
  <Link to={'/dashboard'}  className='dashbacklink'><ArrowBackIcon /> Back to Dashboard</Link>

{/* total member */}
  <div>Total Members : {totalData}</div>

  {/* PAGE SKIP FUNCTIONALITY */}

{/* {
  !isSearchModeOn ?   <div className='member2'>
    <div>{startFrom+1}-{endTo} of {totalData} Members</div>
    <div className={`member3 ${currentPage === 1 ? "disabled" : ""}`} onClick={()=>{handlePrev()}}><KeyboardDoubleArrowLeftIcon/></div>
    <div className={`member3 ${currentPage === noOfPage ? "disabled" : ""}`}  onClick={()=>{handleNext()}}><KeyboardDoubleArrowRightIcon/></div>
  </div> : null
} */}

</div>

{/* Members card */}
<div className="projects__container container grid membercars dashboard-box-1">

{
  data.map((item, index)=>{
    return(
         <MemberCard item={item} />
    );
  })
}

</div>
{ addMembership && <Modal  header="Membership" handleClose={handleMemberShip} content ={<Addmembership handleClose={handleMemberShip} />} />}
{ addMember && <Modal  header="Add New Members" handleClose={handleMembers} content ={<Addmembers />} />}
 <Footer /> 
 <ToastContainer/>
    </div>
    //  <Footer /> 
     
  )
}

export default Member
